import {
  AccountInfo,
  AuthenticationResult,
  Configuration,
  InteractionRequiredAuthError,
  InteractionStatus,
} from '@azure/msal-browser';
import { IMsalContext } from '@azure/msal-react';
const CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
const KNOWN_AUTHORITIES = process.env.REACT_APP_AUTH_KNOWN_AUTHORITIES
  ? process.env.REACT_APP_AUTH_KNOWN_AUTHORITIES.split(',')
  : [];

const SCOPES = ['offline_access', 'openid', ...(CLIENT_ID ? [CLIENT_ID] : [])];

const AuthConfig: Configuration = {
  auth: {
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID as string,
    knownAuthorities: KNOWN_AUTHORITIES,
    postLogoutRedirectUri: process.env.REACT_APP_AUTH_POST_LOGOUT_REDIRECT_URI,
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level: any, message: any): void => {
        if (!['development', 'production'].includes(process.env.NODE_ENV || ''))
          console.log(message);
      },
      piiLoggingEnabled: process.env.NODE_ENV !== 'production',
    },
  },
};

export const getAccessToken = async (
  azureContext: IMsalContext
): Promise<AuthenticationResult | null> => {
  const { instance, inProgress } = azureContext;
  const accounts = await instance.getAllAccounts();
  const account = accounts?.[0];
  const loginRequest = getLoginRequest(account);

  if (account && inProgress === InteractionStatus.None) {
    try {
      const response = await instance.acquireTokenSilent(loginRequest);
      return response;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await instance.loginRedirect(loginRequest);
      } else {
        throw error;
      }
    }
  }

  return null;
};

export const getLoginRequest = (account?: AccountInfo): any => ({
  scopes: [SCOPES.join(' ')],
  ...(account && { account }),
  extraQueryParameters: { brand: 'azmm' },
});

export default AuthConfig;
